module.exports = __webpack_public_path__ + "static/media/ring-white.70a281da.svg";